<template>
  <section class="heat-waves">
    <div v-for="(_, index) in waves" class="heat-wave">
      <div class="remove-btn" @click="removeWave(index)">移除</div>
      <ui-form>
        <template #default="{ subitemClass }">
          <ui-form-field class="required">
            <label>平台：</label>
            <div :class="subitemClass">
              <label
                v-for="{ label, value, disabled } in platformOptions"
                style="display: inline-flex; align-items: center"
                :key="value"
              >
                <ui-radio
                  v-model="waves[index].type"
                  :value="value"
                  :disabled="disabled"
                ></ui-radio>
                {{ label }}
              </label>
            </div>
          </ui-form-field>
          <ui-form-field v-if="waves[index].type === 0" class="required">
            <label>作品BV号：</label>
            <ui-textfield
              maxlength="12"
              placeholder="请填写12位BV号"
              fullwidth
              v-model="waves[index].BV"
            ></ui-textfield>
          </ui-form-field>
          <template v-else>
            <div class="heat-wave-type">
              <div class="heat-wave-type-l">
                <ui-form-field v-if="waves[index].type === 2" class="required">
                  <label>平台名称：</label>
                  <ui-textfield
                    maxlength="20"
                    placeholder="请填写平台名称"
                    fullwidth
                    v-model="waves[index].platform"
                  ></ui-textfield>
                </ui-form-field>
                <ui-form-field v-if="waves[index].type" class="required">
                  <label>作品链接：</label>
                  <ui-textfield
                    placeholder="请输入作品链接，必须是以http://或者https://开头的链接"
                    fullwidth
                    v-model="waves[index].url"
                  ></ui-textfield>
                </ui-form-field>
              </div>
            
              <div v-if="waves[index].type===2" class="type_msg_box">
                <div>提示：如使用视频号进行作品宣传，可参考以下方式获取作品链接<br>
                1.电脑端登录视频号助手<span @click="gotoLink">https://channels.weixin.qq.com/login.html</span><br>
                2.找到视频后点击分享即可复制视频链接</div>
              </div>
            </div>
          </template>
        </template>
      </ui-form>
      <ui-form alignEnd>
        <ui-grid>
          <ui-grid-cell>
            <ui-form-field class="required">
              <label>播放量：</label>
              <ui-textfield
                v-model="waves[index].view"
                inputType="number"
              ></ui-textfield>
            </ui-form-field>
          </ui-grid-cell>
          <ui-grid-cell>
            <ui-form-field class="required">
              <label>点赞量：</label>
              <ui-textfield
                v-model="waves[index].like"
                inputType="number"
              ></ui-textfield>
            </ui-form-field>
          </ui-grid-cell>
          <ui-grid-cell>
            <ui-form-field class="required">
              <label>评论量：</label>
              <ui-textfield
                v-model="waves[index].reply"
                inputType="number"
              ></ui-textfield>
            </ui-form-field>
          </ui-grid-cell>
          <ui-grid-cell v-if="waves[index].type === 0">
            <ui-form-field class="required">
              <label>弹幕数：</label>
              <ui-textfield
                v-model="waves[index].danmaku"
                inputType="number"
              ></ui-textfield>
            </ui-form-field>
          </ui-grid-cell>
          <ui-grid-cell>
            <ui-form-field class="required">
              <label>转发量：</label>
              <ui-textfield
                v-model="waves[index].share"
                inputType="number"
              ></ui-textfield>
            </ui-form-field>
          </ui-grid-cell>
          <ui-grid-cell>
            <ui-form-field class="required">
              <label>收藏量：</label>
              <ui-textfield
                v-model="waves[index].favorite"
                inputType="number"
              ></ui-textfield>
            </ui-form-field>
          </ui-grid-cell>
        </ui-grid>
      </ui-form>
    </div>
    <div class="add-btn" @click="addWave"></div>
  </section>
</template>
<script>
export default {
  name: "heat-wave",
  model: {
    prop: "list",
    event: "change",
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  watch: {
    list(newVal) {
      this.waves = newVal;
    },
    waves: {
      deep: true,
      handler(newVal) {
        this.$emit("change", newVal);
      },
    },
  },
  computed: {
    // 计算属性可以用于处理平台类型的显示逻辑
    platformOptions() {
      let arr = this.platforms.map(({ label, value }) => ({
        label,
        value,
        disabled: value !== 2 && this.waves.some((wave) => wave.type === value),
      }));
      return arr;
      
    },
  },
  data() {
    return {
      platforms: ["bilibili", "抖音", "其他"].map((item, index) => ({
        label: item,
        value: index,
      })),
      waves: this.list || [], // 热浪列表
      typeId:0,
    };
  },
  methods: {
    _createWave() {
      return {
        type: "", // 默认平台为bilibili
        BV: "",
        platform: "",
        url: "",
        view: 0,
        like: 0,
        reply: 0,
        danmaku: 0,
        share: 0,
        favorite: 0,
      };
    },
    addWave() {
      // 添加新热浪的逻辑
      this.waves.push(this._createWave());
    },
    removeWave(index) {
      this.waves.splice(index, 1);
    },
    gotoLink(){
      window.open('https://channels.weixin.qq.com/login.html', '_blank');
    }
  },
};
</script>
